import React, { Component } from "react";
import { withRouter } from 'components/Routing';
import EvaluationButtons from "./components/EvaluationButtons";
import CommentButtons from "./components/CommentButtons";
import EvaluationFormHeader from "./components/Header";
import EvaluationQuestionList from "./components/QuestionList";
import Header from "components/Header";
import "./evaluationform.less";
import config from "root/../config";
import EvaluationFormContext from "../../components/context";

import evaluationsConfig from "../../moduleConfig";
import UIComponent from "components/UiComponent";
import MsgBox from "sis_ui/modules/notifications";
import AppContext from "components/appContext";
import dataService from "services/dataService";
import authService from "services/authService";
import AccessDenied from "components/AccessDenied";
import ActivityLog from "components/ActivityLog";
import Comment from "components/Comment";
import { withTranslation } from "react-i18next";

const sceneCode = "EVALUATION_FORM";

class EvaluationForm extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.headerHight = 145;
    this.observer = null;
    this.bottomRef = React.createRef();
    this.formQuestions = React.createRef();
    const { WORKFLOW_ID } = this.props.router.location.state || { WORKFLOW_ID: "" };
    this.isWorkflowEvaluation = WORKFLOW_ID > 0 ? true : false;

    this.state = {
      userFormID: null,
      questions: null,
      questionsIds: [],
      loadingQuestions:false,
      answers: [],
      details: null,
      placeholders: null,
      scrolled: false,
      focusedQuestionId: null,
      readOnlyForm: true,
      restricted: false,
      showHistory: !this.isWorkflowEvaluation,
      historyLoaded: false,
      historyContent: "",      
      showComment: false,
      commentValue: "",
      selectedWorkflowRuleId: "",
      selectedActionCode: "",
      onBehalf: false,      
    };
  }

  componentDidMount() {
    this.context.setCurrentScene(sceneCode);
    this._getUserForm();
  }

  _getEvaluationHistory(evaluation_id) {
    const historyInputData = {
      rbAlias: "EVALUATION_SCHEDULE_MODULE",
      showComments: true,
      id: `AL_EVALUATION_${evaluation_id}`,
      entity: "AL_EVALUATION",
      key: `{"EVALUATION_ID":${evaluation_id}}`,
      displayMode: "inline",
      triggerElementID: "",
      ajaxCall: true,
      childEntities: "",
      filterChildEntityActions: "",
      displayChanges: true,
      displayLog: true,
      showMessage: true,
      height: "auto",
      excludeEntityFields: "",
      displayTypes: "LIST",
    };
    
    this.historyReq = dataService
      .postRequest({
        url: config.apiAppUrl + evaluationsConfig.APIs.getHistory,
        key: "eventData",
        value: JSON.stringify(historyInputData),
      })
      .accept("application/json");

    try {
      this.historyReq.then((res) => {
        this.setState({
          historyContent: res.body,
        });       
      });
    } catch (e) {
      MsgBox.drawMessage(
        "error",
        this.props.t("lbl.INVALID_RESPONSE", "Invalid response format")
      );
    } finally {
      this.setState({
        historyLoaded: true,
      });
    }
  }
  
  _getUserForm() {
    this.setState(
      {
        readOnlyForm: true,
        loadingQuestions:true,
      },
      () => {
        this.questionsReq = dataService
          .request({
            method: "GET",
            url:
              config.apiAppUrl +
              evaluationsConfig.APIs.getEvaluationForm +
              "/" +
              this.props.router.params.id,
          })
          .accept("application/json");

        this.questionsReq
          .then((res) => {
            try {
              let result = res.body;                   
              const { READ_ONLY, REDIRECTTOOTHERFORM, REDIRECTFORMNAME, REDIRECTUSERFORMID } = result;
              const actionList = "," + result.DETAILS.ACTION_LIST ? result.DETAILS.ACTION_LIST : '' + ",";
              let details = {
                ...result.DETAILS,
                redirectToOtherForm: REDIRECTTOOTHERFORM || false,
                redirectFormName: REDIRECTFORMNAME || '',
                redirectUserFormId: REDIRECTUSERFORMID || null,
              };
              this.setState({
                userFormID: result.USER_FORM_ID,
                questions: result.GROUPS,
                loadingQuestions:false,
                questionsIds: result.GROUPS.reduce((acc, group) => {
                  let groupAcc = acc;
                  group.QUESTIONS.forEach((question) => {
                    if (question.QUESTION_TYPE_CODE != "GENERAL_TEXT")
                      groupAcc.push(question.QUESTION_CD);
                  });
                  return groupAcc;
                }, []),
                answers: result.ANSWERS,
                details: details,
                placeholders: result.PLACEHOLDERS,
                readOnlyForm: READ_ONLY,
                onBehalf: actionList.includes("SUBMIT_ON_BEHALF"),
              },
              () => {
                this._getEvaluationHistory(this.state.details.EVALUATION_ID);
                this._createObserver();
              });
            } catch (e) {
              MsgBox.drawMessage(
                "error",
                this.props.t("lbl.INVALID_RESPONSE", "Invalid response format")
              );
            }
          })
          .catch((e) => {
            if (e.response.statusCode == 403) {
              this.setState({
                restricted: true,
              });
            }
          });          
      }
    );
  }

  componentWillUnmount() {
    if (this.questionsReq) {
      this.questionsReq.abort();
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  _handleScroll(elem) {
    let resetScroll = true;

    if (elem.target.scrollTop == 0){
        resetScroll = true;
        this.setState({
            scrolled : false
        })
    }else if(resetScroll){
        resetScroll = false;
        this.setState({
            scrolled : true
        })
    }
  }

  _handleQuestionFocus = (targetId) => {
    this.setState({
      focusedQuestionId: targetId,
    });
  };

  _inReducer(accumulator, values) {
    return {
      ...accumulator,
      [values.QUESTION_CD]: values.ANSWER_TEXT,
    };
  }

  _outReducer(accumulator, values) {
    let answers = [];
    if (accumulator.hasOwnProperty("answers")) {
      answers = JSON.parse(accumulator.answers);
    }

    let answer = this._updateAnswer(values[0], values[1]);
    if (answer) {
      answers = [...answers, answer];
    }
    return {
      user_form_id: this.state.userFormID,
      evaluation_id: this.state.details.EVALUATION_ID,
      auth_token: authService.getToken(),
      user_role: this.context.userDetails.CURRENT_ROLE,
      answers: JSON.stringify(answers),
      action_comment: this.state.commentValue,
      action_code: this.state.selectedActionCode,
      disabled_form: !this._areEvalsButtonAvailable(),
      onBehalf: this.state.onBehalf,
    };
  }

  _updateAnswer(id, value) {
    return this.state.answers.reduce((acc, answer) => {
      if (answer.QUESTION_CD == id) {
        return {
          ...answer,
          ANSWER_TEXT: value,
        };
      }
      return acc;
    }, null);
  }
 
  _onClickEvalButtonsHandler = ({
    hasComment = false,
    selectedWorkflowRuleId = "",
    selectedActionCode = "",
  }) => {    
    this.setState((prevState) => {      
      return {
        ...prevState,
        showComment: hasComment,
        selectedWorkflowRuleId: selectedWorkflowRuleId,
        selectedActionCode: selectedActionCode,
        showHistory: !hasComment,
      };
    });
  };

  _saveCommentValue = (value) => {
    this.setState({
      commentValue: value,
    });
  };

  _areEvalsButtonAvailable = () =>
    this.state.details &&
    (!this.state.readOnlyForm || this.state.details.WORKFLOW.length > 0);

  _createObserver = () => {
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    this.observer = new IntersectionObserver(this._handleIntersect, options);
    if (this.isWorkflowEvaluation && this.bottomRef.current) {
      setTimeout(()=>this.observer.observe(this.bottomRef.current), 500);      
    }
    if (this.formQuestions.current) {
      this.observer.observe(this.formQuestions.current);
    }
  };

  _handleIntersect = (entries,observer) => {
    entries.forEach((entry) => {
      if (
        entry.target.id === "bottomBar" &&
        !this.state.showHistory &&
        !this.state.showComment
      ) {
        this._handleBottomBarIntersect(entry,observer);
      }     
    });
  };

  _handleBottomBarIntersect = (entry,observer) => {
    if (entry.isIntersecting) {
      this.setState({
        showHistory: true,
      });
      observer.unobserve(this.bottomRef.current);
    }
  };
  
  render() {
    return (
      <EvaluationFormContext.Provider
        value={{
          questions: this.state.questions,
          questionsIds: this.state.questionsIds,
          loadingQuestions: this.state.loadingQuestions,
          details: this.state.details,
          placeholders: this.state.placeholders,
          focusedQuestionId: this.state.focusedQuestionId,
          readOnlyForm: this.state.readOnlyForm,
          handleQuestionFocus: this._handleQuestionFocus.bind(this),
        }}
      >
        <UIComponent
          component="smart-form"
          values={this.state.answers}
          inReducer={this._inReducer.bind(this)}
          outReducer={this._outReducer.bind(this)}
                    class="evaluation-form-scene full-height--with-policy"
        >
          <div className="full-height flex-column row">
            <Header {...this.props} />
            <EvaluationFormHeader headerHight={this.headerHight} />
            {!this.state.restricted ? (
              <React.Fragment>
                <div
                  id="formQuestions"
                  ref={this.formQuestions}
                  className={`evaluation-form-questions col ${
                    !this.state.readOnlyForm ? "pb-5" : ""
                  }`}
                  style={{
                    paddingTop:
                      this.state.questions != null ? this.headerHight - 5 : 0,
                  }}
                  onScroll={(event) => { this.context.updateScrollValue(event.target.scrollTop); this._handleScroll(event) }}
                >
                  {this.state.showComment && (
                    <Comment setValue={this._saveCommentValue.bind(this)} />
                  )}
                  <EvaluationQuestionList
                    className={`${this.state.showComment ? "hide" : "show"}`}
                  />
                    <ActivityLog
                      className={`historyContainer ${
                        this._areEvalsButtonAvailable() ? "full-width" : ""
                      } ${this.state.showHistory ? "show" : "hide"}`}
                      isLoaded={this.state.historyLoaded}
                      htmlContent={this.state.historyContent}                      
                      isActive={this.isWorkflowEvaluation}
                    />
                    {this._areEvalsButtonAvailable() && (
                      <div className="evaluationButtonsContainer">
                        {this.state.showComment ? (
                          <CommentButtons
                            getUserForm={this._getUserForm.bind(this)}
                            onClickHandler={this._onClickEvalButtonsHandler.bind(this)}
                            selectedWorkflowRuleId={
                              this.state.selectedWorkflowRuleId
                            }
                            selectedActionCode={this.state.selectedActionCode}
                          />
                        ) : (
                          <EvaluationButtons
                            formDetails={this.state.details}
                            compact={this.state.scrolled}
                            getUserForm={this._getUserForm.bind(this)}
                            onClickHandler={this._onClickEvalButtonsHandler.bind(this)}
                          />
                        )}
                      </div>
                    )}
                  </div>
                  {this.state.questions != null && (
                    <div
                      id="bottomBar"
                      className="fake-bottom-toolbar"
                      ref={this.bottomRef}
                    ></div>
                  )}
              </React.Fragment>
             
            ) : (
              <AccessDenied />
            )}
          </div>
        </UIComponent>
      </EvaluationFormContext.Provider>
    );
  }
}

export default withRouter(withTranslation()(EvaluationForm));
